import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import app from 'flarum/forum/app';
import icon from 'flarum/common/helpers/icon';
import GuidesModal from './GuidesModal';
export default class NotificationWizardModal extends Modal {
  onsubmit(e) {
    if (e) e.preventDefault();
    this.savePreferences();
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.saving = false;
    this.savedSuccess = false;
    this.requestingPermission = false;
    this.pushSubscribedSuccess = false;
    this.showCustomOptions = false;
    this.checkPermissionStatus();
    this.initPreferences();
  }
  className() {
    return 'NotificationWizardModal Modal--medium';
  }
  title() {
    return app.translator.trans('nagusi-tutorials.forum.notifications_wizard.title') !== 'nagusi-tutorials.forum.notifications_wizard.title' ? app.translator.trans('nagusi-tutorials.forum.notifications_wizard.title') : 'Asistente de Notificaciones';
  }
  checkPermissionStatus() {
    if (!('Notification' in window)) {
      this.permissionStatus = 'unsupported';
    } else {
      this.permissionStatus = window.Notification.permission; // 'default', 'granted', 'denied'
    }
  }
  initPreferences() {
    const user = app.session.user;
    if (!user) {
      this.prefs = {};
      this.activePreset = 'total';
      return;
    }
    const p = user.preferences() || {};
    this.state = {
      mentions: {
        alert: p.notify_postMentioned_alert !== false,
        push: Boolean(p.notify_postMentioned_push),
        email: Boolean(p.notify_postMentioned_email)
      },
      byobu: {
        alert: p.notify_byobuPrivateDiscussionCreated_alert !== false,
        push: Boolean(p.notify_byobuPrivateDiscussionCreated_push),
        email: Boolean(p.notify_byobuPrivateDiscussionCreated_email)
      },
      following: {
        alert: p.notify_newPost_alert !== false,
        push: Boolean(p.notify_newPost_push),
        email: Boolean(p.notify_newPost_email)
      },
      likes: {
        alert: p.notify_postLiked_alert !== false || p.notify_postReacted_alert !== false,
        push: Boolean(p.notify_postLiked_push || p.notify_postReacted_push)
      },
      newDiscussions: {
        alert: Boolean(p.notify_newDiscussion_alert),
        push: Boolean(p.notify_newDiscussion_push),
        email: Boolean(p.notify_newDiscussion_email)
      }
    };

    // Determine initial preset
    if (this.state.mentions.push && this.state.byobu.push && this.state.following.push) {
      this.activePreset = 'total';
    } else if (this.state.mentions.push && this.state.byobu.push && !this.state.following.push) {
      this.activePreset = 'essential';
    } else if (!this.state.following.alert && !this.state.likes.alert) {
      this.activePreset = 'minimal';
    } else {
      this.activePreset = 'total';
    }
    this.showCustomOptions = false;
  }
  applyPreset(presetKey) {
    this.activePreset = presetKey;
    this.savedSuccess = false;
    const isPushAvailable = this.permissionStatus === 'granted';
    if (presetKey === 'total') {
      this.state.mentions = {
        alert: true,
        push: isPushAvailable,
        email: false
      };
      this.state.byobu = {
        alert: true,
        push: isPushAvailable,
        email: false
      };
      this.state.following = {
        alert: true,
        push: isPushAvailable,
        email: false
      };
      this.state.likes = {
        alert: true,
        push: isPushAvailable
      };
      this.state.newDiscussions = {
        alert: true,
        push: false,
        email: false
      };
      this.showCustomOptions = false;
    } else if (presetKey === 'essential') {
      this.state.mentions = {
        alert: true,
        push: isPushAvailable,
        email: false
      };
      this.state.byobu = {
        alert: true,
        push: isPushAvailable,
        email: false
      };
      this.state.following = {
        alert: true,
        push: false,
        email: false
      };
      this.state.likes = {
        alert: true,
        push: false
      };
      this.state.newDiscussions = {
        alert: false,
        push: false,
        email: false
      };
      this.showCustomOptions = false;
    } else if (presetKey === 'minimal') {
      this.state.mentions = {
        alert: true,
        push: false,
        email: false
      };
      this.state.byobu = {
        alert: true,
        push: isPushAvailable,
        email: false
      };
      this.state.following = {
        alert: false,
        push: false,
        email: false
      };
      this.state.likes = {
        alert: false,
        push: false
      };
      this.state.newDiscussions = {
        alert: false,
        push: false,
        email: false
      };
      this.showCustomOptions = false;
    } else if (presetKey === 'custom') {
      this.showCustomOptions = true;
    }
    m.redraw();
  }
  async requestPushPermission() {
    if (!('Notification' in window)) return;
    this.requestingPermission = true;
    m.redraw();
    try {
      const permission = await window.Notification.requestPermission();
      this.permissionStatus = permission;
      if (permission === 'granted') {
        this.pushSubscribedSuccess = true;
        await this.subscribeToPushService();

        // Enable push in active configuration
        this.state.mentions.push = true;
        this.state.byobu.push = true;
        if (this.activePreset === 'total') {
          this.state.following.push = true;
          this.state.likes.push = true;
        }

        // Automatically save updated preferences
        await this.savePreferences();
      }
    } catch (err) {
      console.error('Error requesting push permission:', err);
    } finally {
      this.requestingPermission = false;
      m.redraw();
    }
  }
  async subscribeToPushService() {
    const vapidKey = app.forum.attribute('vapidPublicKey');
    if (!vapidKey || !('serviceWorker' in navigator)) return;
    try {
      const reg = await navigator.serviceWorker.ready;
      if (reg && reg.pushManager) {
        const subscription = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: vapidKey
        });
        await app.request({
          method: 'POST',
          url: app.forum.attribute('apiUrl') + '/pwa/push',
          body: {
            subscription
          },
          errorHandler: () => {}
        });
      }
    } catch (err) {
      console.warn('Push subscription failed or was cancelled:', err);
    }
  }
  async savePreferences() {
    if (!app.session.user) return;
    this.saving = true;
    this.savedSuccess = false;
    m.redraw();
    const p = {};

    // Mentions
    p.notify_postMentioned_alert = this.state.mentions.alert;
    p.notify_postMentioned_push = this.state.mentions.push;
    p.notify_postMentioned_email = this.state.mentions.email;
    p.notify_userMentioned_alert = this.state.mentions.alert;
    p.notify_userMentioned_push = this.state.mentions.push;
    p.notify_userMentioned_email = this.state.mentions.email;
    p.notify_groupMentioned_alert = this.state.mentions.alert;
    p.notify_groupMentioned_push = this.state.mentions.push;
    p.notify_groupMentioned_email = this.state.mentions.email;

    // Byobu
    p.notify_byobuPrivateDiscussionCreated_alert = this.state.byobu.alert;
    p.notify_byobuPrivateDiscussionCreated_push = this.state.byobu.push;
    p.notify_byobuPrivateDiscussionCreated_email = this.state.byobu.email;
    p.notify_byobuPrivateDiscussionReplied_alert = this.state.byobu.alert;
    p.notify_byobuPrivateDiscussionReplied_push = this.state.byobu.push;
    p.notify_byobuPrivateDiscussionReplied_email = this.state.byobu.email;
    p.notify_byobuPrivateDiscussionAdded_alert = this.state.byobu.alert;
    p.notify_byobuPrivateDiscussionAdded_push = this.state.byobu.push;
    p.notify_byobuPrivateDiscussionAdded_email = this.state.byobu.email;

    // Following discussions
    p.notify_newPost_alert = this.state.following.alert;
    p.notify_newPost_push = this.state.following.push;
    p.notify_newPost_email = this.state.following.email;

    // Likes & Reactions
    p.notify_postLiked_alert = this.state.likes.alert;
    p.notify_postLiked_push = this.state.likes.push;
    p.notify_postReacted_alert = this.state.likes.alert;
    p.notify_postReacted_push = this.state.likes.push;

    // New discussions in followed tags
    p.notify_newDiscussion_alert = this.state.newDiscussions.alert;
    p.notify_newDiscussion_push = this.state.newDiscussions.push;
    p.notify_newDiscussion_email = this.state.newDiscussions.email;
    try {
      await app.session.user.savePreferences(p);
      this.saving = false;
      this.savedSuccess = true;
      m.redraw();
      setTimeout(() => {
        app.modal.close();
      }, 1200);
    } catch (e) {
      this.saving = false;
      m.redraw();
      app.alerts.show({
        type: 'error'
      }, 'No se pudieron guardar las preferencias');
    }
  }
  content() {
    const user = app.session.user;
    return m("div", {
      className: "Modal-body NotificationWizardModal-body"
    }, this.attrs.fromGuides && m("button", {
      type: "button",
      className: "Button Button--link NotificationWizard-backBtn",
      onclick: e => {
        e.preventDefault();
        e.stopPropagation();
        app.modal.show(GuidesModal);
      }
    }, m("i", {
      className: "fas fa-chevron-left"
    }), " ", app.translator.trans('nagusi-tutorials.forum.notifications_wizard.back_to_guides') || 'Volver al catálogo de Guías'), m("div", {
      className: "NotificationWizard-header"
    }, m("div", {
      className: "NotificationWizard-badge"
    }, m("i", {
      className: "fas fa-bell"
    })), m("div", {
      className: "NotificationWizard-titleBlock"
    }, m("h2", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.subtitle') || 'Elige cómo y cuándo quieres que te avisemos'), m("p", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.desc') || 'Ajusta tus notificaciones para no perderte goles, porras, menciones ni debates sin saturar tu móvil.'))), !user ? m("div", {
      className: "NotificationWizard-loginRequired Alert Alert--warning"
    }, m("i", {
      className: "fas fa-user-lock"
    }), m("p", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.login_required') || 'Debes iniciar sesión para configurar tus notificaciones.')) : m("div", {
      className: "NotificationWizard-content"
    }, m("div", {
      className: "NotificationWizard-card NotificationWizard-deviceCard"
    }, m("div", {
      className: "NotificationWizard-cardHeader"
    }, m("span", {
      className: "NotificationWizard-stepNum"
    }, "1"), m("div", null, m("h3", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.push_section_title') || 'Notificaciones en este Dispositivo'), m("p", {
      className: "NotificationWizard-cardSubtitle"
    }, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.push_permission_prompt') || 'Para recibir avisos aunque no tengas el navegador abierto (como en una app), activa el permiso:'))), m("div", {
      className: "NotificationWizard-permissionState"
    }, this.permissionStatus === 'granted' ? m("div", {
      className: "NotificationWizard-grantedBanner"
    }, m("i", {
      className: "fas fa-check-circle"
    }), m("span", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.push_granted') || 'Notificaciones de pantalla activadas en este dispositivo.')) : this.permissionStatus === 'denied' ? m("div", {
      className: "NotificationWizard-deniedBanner"
    }, m("i", {
      className: "fas fa-exclamation-triangle"
    }), m("div", null, m("strong", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.push_denied_title') || 'Permiso bloqueado en el navegador'), m("p", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.push_denied') || 'Para activarlas, pulsa el icono del candado 🔒 junto a la barra de direcciones y cambia Notificaciones a Permitir.'))) : this.permissionStatus === 'unsupported' ? m("div", {
      className: "NotificationWizard-unsupportedBanner"
    }, m("i", {
      className: "fas fa-info-circle"
    }), m("span", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.push_unsupported') || 'Tu navegador actual no soporta Web Push, pero verás las alertas en la campana del foro.')) : m("div", {
      className: "NotificationWizard-promptAction"
    }, m(Button, {
      type: "button",
      className: "Button Button--primary NotificationWizard-btnPush",
      icon: "fas fa-bell",
      loading: this.requestingPermission,
      onclick: e => {
        e.preventDefault();
        this.requestPushPermission();
      }
    }, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.push_activate_button') || 'Activar notificaciones en este dispositivo')))), m("div", {
      className: "NotificationWizard-card NotificationWizard-presetsCard"
    }, m("div", {
      className: "NotificationWizard-cardHeader"
    }, m("span", {
      className: "NotificationWizard-stepNum"
    }, "2"), m("div", null, m("h3", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.presets_title') || 'Elige tu Perfil de Notificaciones'), m("p", {
      className: "NotificationWizard-cardSubtitle"
    }, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.presets_subtitle') || 'Selecciona un modo recomendado con un solo clic:'))), m("div", {
      className: "NotificationWizard-presetsGrid"
    }, m("div", {
      className: "NotificationWizard-presetItem ".concat(this.activePreset === 'total' ? 'is-active' : ''),
      onclick: () => this.applyPreset('total')
    }, m("div", {
      className: "NotificationWizard-presetHead"
    }, m("span", {
      className: "NotificationWizard-presetIcon"
    }, "\uD83E\uDD81"), m("strong", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.preset_total_title') || 'Forero Total'), m("span", {
      className: "NotificationWizard-presetBadge"
    }, "Recomendado")), m("p", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.preset_total_desc') || 'Avisos de menciones, respuestas, privados, porras y temas seguidos.')), m("div", {
      className: "NotificationWizard-presetItem ".concat(this.activePreset === 'essential' ? 'is-active' : ''),
      onclick: () => this.applyPreset('essential')
    }, m("div", {
      className: "NotificationWizard-presetHead"
    }, m("span", {
      className: "NotificationWizard-presetIcon"
    }, "\u26A1"), m("strong", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.preset_essential_title') || 'Esencial')), m("p", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.preset_essential_desc') || 'Solo lo tuyo: cuando te mencionan (@ti), te responden o te envían mensajes privados.')), m("div", {
      className: "NotificationWizard-presetItem ".concat(this.activePreset === 'minimal' ? 'is-active' : ''),
      onclick: () => this.applyPreset('minimal')
    }, m("div", {
      className: "NotificationWizard-presetHead"
    }, m("span", {
      className: "NotificationWizard-presetIcon"
    }, "\uD83E\uDDD8"), m("strong", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.preset_minimal_title') || 'Tranquilo')), m("p", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.preset_minimal_desc') || 'Cero distracciones: solo mensajes privados y menciones indispensables.'))), m("div", {
      className: "NotificationWizard-toggleCustom"
    }, m("button", {
      type: "button",
      className: "Button Button--link",
      onclick: e => {
        e.preventDefault();
        e.stopPropagation();
        this.showCustomOptions = !this.showCustomOptions;
        if (this.showCustomOptions) {
          this.activePreset = 'custom';
          setTimeout(() => {
            const customEl = document.querySelector('.NotificationWizard-customCard');
            if (customEl) customEl.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest'
            });
          }, 50);
        }
        m.redraw();
      }
    }, m("i", {
      className: "fas fa-chevron-".concat(this.showCustomOptions ? 'up' : 'down')
    }), ' ', this.showCustomOptions ? 'Ocultar ajustes avanzados' : '¿Quieres afinar cada detalle? Personalizar canales por separado'))), this.showCustomOptions && m("div", {
      className: "NotificationWizard-card NotificationWizard-customCard"
    }, m("h3", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.customize_title') || 'Personalizar Categorías'), m("div", {
      className: "NotificationWizard-customList"
    }, m("div", {
      className: "NotificationWizard-customRow"
    }, m("div", {
      className: "NotificationWizard-customInfo"
    }, m("i", {
      className: "fas fa-at"
    }), m("div", null, m("strong", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.types.mentions_title') || 'Menciones y Respuestas'), m("p", null, "Cuando alguien cita tu usuario (@ti) o responde a un mensaje tuyo."))), m("div", {
      className: "NotificationWizard-customChannels"
    }, m("label", {
      className: "NotificationWizard-channelLabel"
    }, m(Switch, {
      state: this.state.mentions.alert,
      onchange: v => {
        this.state.mentions.alert = v;
        this.activePreset = 'custom';
      }
    }, "Campana")), m("label", {
      className: "NotificationWizard-channelLabel"
    }, m(Switch, {
      state: this.state.mentions.push,
      disabled: this.permissionStatus !== 'granted',
      onchange: v => {
        this.state.mentions.push = v;
        this.activePreset = 'custom';
      }
    }, "Push")))), m("div", {
      className: "NotificationWizard-customRow"
    }, m("div", {
      className: "NotificationWizard-customInfo"
    }, m("i", {
      className: "fas fa-envelope"
    }), m("div", null, m("strong", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.types.byobu_title') || 'Mensajes Privados'), m("p", null, "Avisos de conversaciones y respuestas privadas."))), m("div", {
      className: "NotificationWizard-customChannels"
    }, m("label", {
      className: "NotificationWizard-channelLabel"
    }, m(Switch, {
      state: this.state.byobu.alert,
      onchange: v => {
        this.state.byobu.alert = v;
        this.activePreset = 'custom';
      }
    }, "Campana")), m("label", {
      className: "NotificationWizard-channelLabel"
    }, m(Switch, {
      state: this.state.byobu.push,
      disabled: this.permissionStatus !== 'granted',
      onchange: v => {
        this.state.byobu.push = v;
        this.activePreset = 'custom';
      }
    }, "Push")))), m("div", {
      className: "NotificationWizard-customRow"
    }, m("div", {
      className: "NotificationWizard-customInfo"
    }, m("i", {
      className: "fas fa-star"
    }), m("div", null, m("strong", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.types.following_title') || 'Discusiones que sigues'), m("p", null, "Nuevos mensajes en los hilos marcados como seguidos."))), m("div", {
      className: "NotificationWizard-customChannels"
    }, m("label", {
      className: "NotificationWizard-channelLabel"
    }, m(Switch, {
      state: this.state.following.alert,
      onchange: v => {
        this.state.following.alert = v;
        this.activePreset = 'custom';
      }
    }, "Campana")), m("label", {
      className: "NotificationWizard-channelLabel"
    }, m(Switch, {
      state: this.state.following.push,
      disabled: this.permissionStatus !== 'granted',
      onchange: v => {
        this.state.following.push = v;
        this.activePreset = 'custom';
      }
    }, "Push")))), m("div", {
      className: "NotificationWizard-customRow"
    }, m("div", {
      className: "NotificationWizard-customInfo"
    }, m("i", {
      className: "fas fa-heart"
    }), m("div", null, m("strong", null, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.types.likes_title') || 'Reacciones y Me Gustas'), m("p", null, "Cuando otros foreros reaccionan a tus comentarios."))), m("div", {
      className: "NotificationWizard-customChannels"
    }, m("label", {
      className: "NotificationWizard-channelLabel"
    }, m(Switch, {
      state: this.state.likes.alert,
      onchange: v => {
        this.state.likes.alert = v;
        this.activePreset = 'custom';
      }
    }, "Campana")), m("label", {
      className: "NotificationWizard-channelLabel"
    }, m(Switch, {
      state: this.state.likes.push,
      disabled: this.permissionStatus !== 'granted',
      onchange: v => {
        this.state.likes.push = v;
        this.activePreset = 'custom';
      }
    }, "Push")))))), m("div", {
      className: "NotificationWizard-footer"
    }, this.savedSuccess && m("div", {
      className: "NotificationWizard-successMsg"
    }, m("i", {
      className: "fas fa-check-circle"
    }), ' ', app.translator.trans('nagusi-tutorials.forum.notifications_wizard.saved_success') || '¡Preferencias guardadas con éxito!'), m("div", {
      className: "NotificationWizard-actionButtons"
    }, m(Button, {
      className: "Button Button--primary NotificationWizard-btnSave",
      icon: "fas fa-save",
      loading: this.saving,
      onclick: () => this.savePreferences()
    }, app.translator.trans('nagusi-tutorials.forum.notifications_wizard.save_button') || 'Guardar Configuración')))));
  }
}
_defineProperty(NotificationWizardModal, "isDismissibleViaBackdropClick", false);
flarum.reg.add('nagusi-match-ratings', 'forum/tutorials/NotificationWizardModal', NotificationWizardModal);